export default "__VITE_ASSET__C4g$KSGu__"